export const escapeCSV = (value: unknown): string => {
	if (value === null || value === undefined) {
		return '';
	}

	const str = String(value);
	if (/[",\n]/.test(str)) {
		return `"${str.replace(/"/g, '""')}"`;
	}

	return str;
};
